module.exports = __webpack_public_path__ + "img/icon_text_right@2x.b5cd2236.png";